export default __webpack_public_path__ + "static/media/Biology_01_02.2eed3cb2.png";